// events on load
document.addEventListener("DOMContentLoaded", () => {
    mobileMenuInit(
        "[data-nav-toggler]",
        "[data-nav-target]",
        "nav-is-open",
        "[data-nav-closer]"
    );
    mobileVhInit();
    fixedHeaderInit();
    privacyPopupInit("paf2019", "010119");
});

// events on resize
window.onresize = function () {
    mobileVhInit();
};
